import * as React from "react"
const SvgCloseFullScreen = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10 15.4-5.9 5.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7L8.6 14H5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 4 13q0-.424.288-.713A.97.97 0 0 1 5 12h6q.424 0 .713.287.287.288.287.713v6q0 .424-.287.712A.97.97 0 0 1 11 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 19zm5.4-5.4H19q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 19 12h-6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 11V5q0-.424.287-.712A.97.97 0 0 1 13 4q.424 0 .713.288Q14 4.575 14 5v3.6l5.9-5.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7z" />
  </svg>
)
export default SvgCloseFullScreen
